module.exports = __webpack_public_path__ + "static/media/icon-header-financial.a08bae5c.svg";